// extracted by mini-css-extract-plugin
export default {"overflow_container":"Practices_overflow_container__rMxZK"};